export const AUTH_LOGIN = '[AUTH] LOGIN'
export const AUTH_LOGIN_SUCCESS = '[AUTH] LOGIN_SUCCESS'
export const AUTH_LOGIN_ERROR = '[AUTH] LOGIN_ERROR'

export const AUTH_LOGOUT = '[AUTH] LOGOUT'
export const AUTH_LOGOUT_SUCCESS = '[AUTH] LOGOUT_SUCCESS'
export const AUTH_LOGOUT_ERROR = '[AUTH] LOGOUT_ERROR'

export const AUTH_OTP = '[AUTH] OTP'
export const AUTH_OTP_SUCCESS = '[AUTH] OTP_SUCCESS'
export const AUTH_OTP_ERROR = '[AUTH] OTP_ERROR'

export const Login = (credentials: { email: string }) => ({
  type: AUTH_LOGIN,
  payload: credentials,
})

export const LoginSuccess = (credentials: { email: string }, data: boolean) => ({
  type: AUTH_LOGIN_SUCCESS,
  payload: {
    user: {
      email: credentials.email,
    },
    success: data,
  },
})

export const LoginError = (errors?: Array<{ [key: string]: string }>) => ({
  type: AUTH_LOGIN_ERROR,
  payload: errors,
})

export const Logout = () => ({
  type: AUTH_LOGOUT,
})

export const LogoutSuccess = () => ({
  type: AUTH_LOGOUT_SUCCESS,
})

export const LogoutError = () => ({
  type: AUTH_LOGOUT_ERROR,
})

export const Otp = (email: string, token: string) => ({
  type: AUTH_OTP,
  payload: { email, token },
})

export const OtpSuccess = (data: any) => ({
  type: AUTH_OTP_SUCCESS,
  payload: data,
})

export const OtpError = (errors?: Array<{ [key: string]: string }>) => ({
  type: AUTH_OTP_ERROR,
  payload: errors,
})
